"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forIE11 = void 0;
var styled_components_1 = require("styled-components");
/**
 *
 * @deprecated We dont need anymore to support IE11
 */
var forIE11 = function (properties) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    html[data-useragent*='Trident/7'] & {\n        ", "\n    }\n"], ["\n    html[data-useragent*='Trident/7'] & {\n        ", "\n    }\n"])), properties); };
exports.forIE11 = forIE11;
var templateObject_1;
//# sourceMappingURL=ie11.js.map